<template>
    <footer>
        <router-link v-if="properties.link.length > 0 && properties.link[0].internalLink !== null" 
                :to="getRouteFromID(properties.link[0].internalLink)" v-html="properties.link[0].linkText"></router-link>

        <a v-else-if="properties.link.length > 0 && properties.link[0].linkUrl !== ''" 
            :href="properties.link[0].linkUrl" v-html="properties.link[0].linkText" target="_blank" @click="trackExternalLink(properties.link[0].linkUrl)"></a>
    </footer>
</template>
<script>
export default {
    props: ["properties", "pageData"],
    methods: {
        getRouteFromID(id) {
            return app.manifest.getRouteFromID(id);
        },
        trackExternalLink(url) {
           // _paq.push(["trackEvent", "external-link", window.app.vm.$route.path, url]);
        }
    }
}
</script>
<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';
footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--dark-grey);
    width: 100%;
    height: 180px;
    z-index: 3;
    margin-top: auto;

    a {
        position: relative;
        font-size: 20px;
        font-weight: 700;
        text-transform: uppercase;
        color: #fff;
        width: 100%;
        max-width: var(--content-max-width);
        padding: var(--content-padding);
        text-align: left;

       
        
        &::after {
            content: '';
            position: absolute;
            width: 60px;
            height: 60px;
            top: 50%;
            transform: translateY(-50%);
            right: 20px;
            background-image: url(@/assets/img/ui/btn-next.svg);
            background-position: center;
            background-repeat: no-repeat;
            transition: var(--tk-easeinout) 0.1s transform;
            transform-origin: 50% 0;
        }
        
        &:hover {
            &::after {
                transform: scale(1.05) translateY(-50%);
            }
        }
    }

    strong {
        color: var(--secondary-color);
    }

    @include mobile-only {
        align-items: flex-start;

        height: 210px;
        padding-top: 40px;
        strong{
            display: block;
        }
    }
}
</style>